import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import Model from '../../utils/model'// Adjust the import path for the modal
import "./Contact.css";

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    icon: "/img/check_green.svg", // Replace with your desired icon
    header: "We've Recived Your Request",
    body: "Thank you for sharing your concerns with rentai.Our team will reviewing your message and will reach out to you shortly to help resolve the issue.",
    button:'Got it',
    handleSuccess: () => {
      console.log("Modal button clicked!"); 
      window.location.href = '/rentai';
  }
    
  });

  const onSubmit = (data) => {
    console.log(data);
    // Handle form submission logic here

    // Show the modal on successful submission
    setShowModal(true);
  };

  return (
    <section className="contactMain" id="">
      <div className="container">
        <div className="contactOuter">
          <img className="contact_1" src="/img/rentai/union.svg" alt="contact us" />
          <div className="row justify-content-center align-items-center">
            {/* Left Section */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="contactLeft">
                <h2>What’s your problem?</h2>
                <h3>
                  <span>rentii</span> can solve it.
                </h3>
                <p>
                  Tell us about your rental challenges, and we'll take care of the rest.
                  Powered by Rentii, we're here to help owners work smarter and more
                  efficiently. So, what's your problem?
                </p>
              </div>
            </div>

            {/* Right Section */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="contactRight">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    {/* First Name */}
                    <div className="col-lg-6">
                      <div className="mb-4">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          {...register("firstName", { required: true })}
                          className="form-control"
                          placeholder="Enter first name"
                        />
                        {errors.firstName && (
                          <div className="text-danger small">First Name is required</div>
                        )}
                      </div>
                    </div>

                    {/* Last Name */}
                    <div className="col-lg-6">
                      <div className="mb-4">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          {...register("lastName", { required: true })}
                          className="form-control"
                          placeholder="Enter last name"
                        />
                        {errors.lastName && (
                          <div className="text-danger small">Last Name is required</div>
                        )}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-lg-12">
                      <div className="mb-4">
                        <label className="form-label">Email Address</label>
                        <input
                          type="email"
                          {...register("email", { required: true })}
                          className="form-control"
                          placeholder="Enter your email"
                        />
                        {errors.email && (
                          <div className="text-danger small">Email is required</div>
                        )}
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="col-lg-12">
                      <div className="mb-4">
                        <label className="form-label">Phone</label>
                        <Controller
                          name="phone"
                          control={control}
                          rules={{
                            required: "Phone number is required",
                            validate: (value) =>
                              value && value.length >= 10 || "Phone number must be valid",
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              {...field}
                              id="phone_number"
                              limitMaxLength="10"
                              defaultCountry="US"
                              placeholder="XXX-XXX-XXX"
                              onChange={(value) => field.onChange(value)}
                              value={field.value || ""}
                            />
                          )}
                        />
                        {errors.phone && (
                          <div className="text-danger small">{errors.phone.message}</div>
                        )}
                      </div>
                    </div>

                    {/* Message */}
                    <div className="col-lg-12">
                      <div className="mb-4">
                        <label className="form-label">Message</label>
                        <textarea
                          {...register("message", { required: true })}
                          className="form-control"
                          placeholder="Enter your message"
                          rows="4"
                        ></textarea>
                        {errors.message && (
                          <div className="text-danger small">Message is required</div>
                        )}
                      </div>
                    </div>

                    {/* Privacy Policy */}
                    {/* <div className="col-lg-12">
                      <div className="form-check mb-4">
                        <input
                          type="checkbox"
                          {...register("privacyPolicy", { required: true })}
                          className="form-check-input"
                          id="privacyPolicy"
                        />
                        <label className="form-check-label" htmlFor="privacyPolicy">
                          I agree with the Rentii Privacy Policy.
                        </label>
                        {errors.privacyPolicy && (
                          <div className="text-danger small">Required</div>
                        )}
                      </div>
                    </div> */}

                    <div className="col-lg-12">
                      <div className="mb-4">
                        <label className="checkCustom">I agree with the Rentid Privacy Policy.
                          <input type="checkbox"/>
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="col-lg-12">
                      <button type="submit" className="btn submit w-100">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Model
        prop={{
          show: showModal,
          setShow: setShowModal,
          content: modalContent,
        }}
      />
    </section>
  );
};

export default ContactForm;
